import { render, staticRenderFns } from "./salaryDataMgr.vue?vue&type=template&id=3322d7f2&scoped=true"
import script from "./salaryDataMgr.vue?vue&type=script&lang=js"
export * from "./salaryDataMgr.vue?vue&type=script&lang=js"
import style0 from "./salaryDataMgr.vue?vue&type=style&index=0&id=3322d7f2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3322d7f2",
  null
  
)

export default component.exports